var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("circle", {
        attrs: {
          cx: "7",
          cy: "8",
          r: "1.8",
          stroke: _vm.color,
          "stroke-width": "1.6"
        }
      }),
      _c("circle", {
        attrs: {
          cx: "12",
          cy: "6",
          r: "1.8",
          stroke: _vm.color,
          "stroke-width": "1.6"
        }
      }),
      _c("circle", {
        attrs: {
          cx: "17",
          cy: "8",
          r: "1.8",
          stroke: _vm.color,
          "stroke-width": "1.6"
        }
      }),
      _c("circle", {
        attrs: {
          cx: "19",
          cy: "13",
          r: "1.6",
          stroke: _vm.color,
          "stroke-width": "1.6"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M12 11a4 4 0 0 1 3.7 2.5l.7 1.7A2.4 2.4 0 0 1 14.2 18.5c-.8 0-1.5-.4-2.2-.4s-1.4.4-2.2.4a2.4 2.4 0 0 1-2.2-3.3l.7-1.7A4 4 0 0 1 12 11z",
          stroke: _vm.color,
          "stroke-width": "1.6",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }